export default "/_next/static/images/header-bg-84d60c972ff4158736640f6b7380f253.png";